<template>
    <div>
        <div v-bind:class="ContentBlockBaseProps.Class" v-bind:style="ContentBlockBaseProps.Style">
            <div :class="BlockProps.Shadow? 'shadow-sm mb-3' : ''" :style="{'background-color' : BlockProps.BGColor + ' !important'}">
                <div class="container" v-bind:style="ContainerPadding">
                    <div class="row justify-content-lg-between mx-5 shadow-sm" style="background-color:white" :style="{ 'flex-direction': BlockProps.Flipped ? 'row-reverse' : 'row' }">

                        <div class="col-lg-7 px-5">
                            <div class="row">
                                <div class="col-12">
                                    <omnieditor :iseditmode="iseditmode" editortype="tinymce" keyDown v-model="BlockProps.Leadin" tag-name="div" :init="EditorConfig" />
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    *Your Name:
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-6">
                                    <input v-model="FirstName" type="text" class="form-control" placeholder="First Name" />
                                </div>
                                <div class="col-6">
                                    <input v-model="LastName" type="text" class="form-control" placeholder="Last Name" />
                                </div>
                            </div>


                            <div class="row mt-5">
                                <div class="col-12">
                                    *E-Mail Address:
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <input v-model="EMail" type="text" class="form-control" placeholder="youremail@domain.com" />
                                </div>
                            </div>

                            <div class="row mt-5">
                                <div class="col-12">
                                    Phone Number:
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <input v-model="Phone" type="text" class="form-control" placeholder="555-555-5555" />
                                </div>
                            </div>

                            <div class="row mt-5">
                                <div class="col-12">
                                    Message:
                                </div>
                            </div>

                            <div class="row">
                                <div class="col-12">
                                    <textarea v-model="Message" rows="5" maxlength="2000" class="form-control" placeholder="Write us a message." />
                                </div>
                            </div>

                            <div class="row mt-4" v-if="ShouldUseRecaptcha">
                                <div class="col-12 text-center">
                                    <div ref="recaptchaContainer" class="d-inline-block"></div>                                    
                                </div>
                            </div>

                            <div class="row mt-5 mb-5">
                                <div class="col-12 text-center">
                                    <button @click="OnSubmit" class="btn btn-primary btn-sm">Send It</button>
                                </div>
                            </div>
                        </div>

                        <div class="col-lg-5 contact-content" style="min-height:600px; padding-left:50px;padding-top:100px;" :style="{'background-image': 'url(' + BlockProps.Img1 + ')'}">
                            <div v-if="HasAddressComponent">
                                <div class="row">
                                    <div class="col-1"><i class="bi-pin-map"></i></div>
                                    <div class="col-11 fw-bold" style="padding-left:30px;">Mailing Address</div>
                                </div>
                                <div class="row justify-content-end">
                                    <div class="col-11" style="padding-left: 30px; margin-top: 15px; color:#c7c7c7">
                                        {{TenantConfig.customerServiceStreet}}<br v-if="TenantConfig.customerServiceStreet" />
                                        {{TenantConfig.customerServiceCity}}<span v-if="TenantConfig.customerServiceCity">, </span>{{TenantConfig.customerServiceState}} {{TenantConfig.customerServiceZip}}
                                    </div>

                                </div>
                            </div>

                            <div v-bind:style="HasAddressComponent? { 'margin-top': '50px' } : null" v-if="TenantConfig.customerServicePhone">
                                <div class="row">
                                    <div class="col-1"><i class="bi-telephone-outbound"></i></div>
                                    <div class="col-11 fw-bold" style="padding-left:30px;">Call Us</div>
                                </div>
                                <div class="row justify-content-end">
                                    <div class="col-11" style="padding-left: 30px; margin-top: 15px; color:#c7c7c7">
                                        <a :href="'tel:' + TenantConfig.customerServicePhone">{{TenantConfig.customerServicePhone}}</a>
                                        <span class="text-muted small" v-if="TenantConfig.customerServicePhoneAvail">
                                            <br />
                                            {{TenantConfig.customerServicePhoneAvail}}
                                        </span>
                                    </div>

                                </div>
                            </div>
                            <div style="margin-top:50px">
                                <div class="row">
                                    <div class="col-1"><i class="bi-envelope"></i></div>
                                    <div class="col-11 fw-bold" style="padding-left:30px;">E-Mail Support</div>
                                </div>
                                <div class="row justify-content-end">
                                    <div class="col-11" style="padding-left: 30px; margin-top: 15px; color:#c7c7c7">
                                        <a :href="'mailto:' + TenantConfig.customerServiceEmail">{{TenantConfig.customerServiceEmail}}</a>
                                    </div>

                                </div>
                            </div>
                        </div>

                    </div>

                    <!-- End Row -->
                </div>
            </div>
        </div>

        <div v-if="iseditmode" style="z-index:300" class="modal" :id="'editor' + BlockProps.UId" tabindex="-1" aria-hidden="true" data-bs-backdrop="static" data-bs-keyboard="false">
            <div class="modal-dialog modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="exampleModalLabel">Options</h5>
                    </div>
                    <div class="modal-body">
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <propertybaseeditors :blockprops="BlockProps" :additionalcfg="AdditionalCfg"></propertybaseeditors>

                        <small style="font-size:12px;"><i class="bi bi-info-circle"></i>  Background Image (75kb max, each)</small>
                        <hr style="margin: 0px; margin-bottom:10px;" />
                        <div class="row">
                            <div class="col col-12 text">
                                <div style="display:inline-block; width: 100px !important;height: 75px !important;">
                                    <img style="object-fit:cover; width:100% !important; height:100% !important;object-position:center  !important;box-shadow: rgba(0, 0, 0, 0.24) 0px 3px 8px; border: 1px solid black" :src="BlockProps.Img1" alt="Image1" />
                                </div>
                                <i class="bi bi-chevron-double-right"></i>
                                <button @click="UploadNewSlideBackground(1)" type="button" style="margin-left:5px;" class="btn btn-sm btn-primary"><i class="bi bi-image"></i> Change Image</button>
                            </div>
                            <hr style="margin-top: 5px; margin-bottom:5px;" />
                        </div>

                        <propertytogglededitor propertyname="Flipped" :blockprops="BlockProps" prompt="Flip Layout"></propertytogglededitor>

                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-sm btn-secondary" data-bs-dismiss="modal">Done</button>
                        <!--<button type="button" class="btn btn-sm btn-primary">Save changes</button>-->
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
    import EventHub from '/src/Util/EventHub.js';
    import ContentBlockBase from '/src/components/ContentCreator/ContentBlockBase.vue'
    import { computed, ref, nextTick } from 'vue'
    import { toast } from 'vue3-toastify';
    import axios from '/src/components/NovaAxios.js';

    export default {
        inheritAttrs: false,
        name: 'ContactForm',
        mixins: [ContentBlockBase],
        props: ['tenantconfig'],
        components: {
        },
        computed:
        {
            HasAddressComponent: function () {
                return this.TenantConfig.customerServiceStreet
                    || this.TenantConfig.customerServiceCity
                    || this.TenantConfig.customerServiceState
                    || this.TenantConfig.customerServiceZip;
            },
            TenantConfig: function () {
                var x = this.Store.TenantConfig;
                if (this.tenantconfig) {
                    return this.tenantconfig
                }

                if (this.Store && this.Store.TenantConfig && this.Store.TenantConfig) {
                    return this.Store.TenantConfig;
                }
            },
            ShouldUseRecaptcha: function () {
                return !!this.RecaptchaSiteKey;
            }
        },
        data() {
            return {  
                AdditionalCfg: 'https://admin.notarylaunchpad.com/home/sitesettings#CoreSettings',
                FirstName: '',
                LastName: '',
                EMail: '',
                Phone: '',
                Message: '',
                RecaptchaSiteKey: typeof window !== 'undefined' ? (window._CONTACT_RECAPTCHA_SITE_KEY || '') : '',
                RecaptchaWidgetId: null,
                RecaptchaToken: '',
                RecaptchaCallbackRef: null
            };
        },
        methods:
        {
            OnSubmit: function () {
                EventHub.$emit("PageLoading", true);
                var err = "";
                if (!this.FirstName || this.FirstName.length < 2) {
                    err += "<li>First Name must be at least 2 characters long.</li>";
                }

                if (!this.LastName || this.LastName.length < 2) {
                    err += "<li>Last Name must be at least 2 characters long.</li>";
                }

                var emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
                if (!this.EMail || this.EMail.length < 2 || !emailPattern.test(this.EMail)) {
                    err += "<li>Must provide a valid email address.</li>";
                }

                if (!this.Message || this.Message.length < 10) {
                    err += "<li>Message must be at least 10 characters long.</li>";
                }

                if (this.ShouldUseRecaptcha && !this.RecaptchaToken) {
                    err += "<li>Please verify that you are not a robot.</li>";
                }

                if (err) {
                    err = `<ul>${err}</ul>`;
                    toast.error(err);
                    EventHub.$emit("PageLoading", false);
                    return;
                }

                var that = this;
                var token = document.querySelectorAll('input[name=__RequestVerificationToken]')[0].value;
                axios.postForm('/API/SubmitContactUs', {
                    fname: this.FirstName,
                    lname: this.LastName,
                    email: this.EMail,
                    phone: this.Phone,
                    msg: this.Message,
                    captchaToken: this.RecaptchaToken
                }, {
                    cache: false,
                    headers: {
                        'RequestVerificationToken': token
                    }
                }).then(function (response) {
                    EventHub.$emit("PageLoading", false);

                    if (response.data.success) {
                        toast.success("Your message was received. We'll get back to you shortly! Thank you.");
                        that.FirstName = '';
                        that.LastName = '';
                        that.EMail = '';
                        that.Phone = '';
                        that.Message = '';
                        that.resetRecaptcha();
                    }
                    else {
                        toast.error("There was an error. " + response.data.msg);
                        that.resetRecaptcha();
                    }
                }).catch(function (error) {
                    EventHub.$emit("PageLoading", false);
                    that.resetRecaptcha();
                    toast.error("There was an error. Please refresh the page and try again.");
                });
            },
            OnSlideImageUploaded: function (args) {
                if (args.success)
                {
                    if (this.BlockProps[args.idx] && args.url){
                        this.BlockProps[args.idx] = args.url;                    
                    }
                }
                
                this.EditProperties();
            },
            resetRecaptcha: function () {
                if (!this.ShouldUseRecaptcha) {
                    return;
                }
                this.RecaptchaToken = '';
                if (window.grecaptcha && window.grecaptcha.enterprise && this.RecaptchaWidgetId !== null) {
                    window.grecaptcha.enterprise.reset(this.RecaptchaWidgetId);
                }
            },
            prepareRecaptcha: function () {
                if (!this.ShouldUseRecaptcha || this.RecaptchaWidgetId !== null) {
                    return;
                }

                const renderFn = () => {
                    this.renderRecaptcha();
                };

                this.RecaptchaCallbackRef = renderFn;

                if (window.grecaptcha && window.grecaptcha.enterprise && window.grecaptcha.enterprise.render) {
                    renderFn();
                    return;
                }

                window.__contactRecaptchaCallbacks = window.__contactRecaptchaCallbacks || [];
                window.__contactRecaptchaCallbacks.push(renderFn);

                if (!window.__contactRecaptchaScriptAdded) {
                    window.__contactRecaptchaOnload = () => {
                        window.__contactRecaptchaReady = true;
                        (window.__contactRecaptchaCallbacks || []).forEach(cb => {
                            try {
                                cb();
                            } catch (error) {
                                console.error(error);
                            }
                        });
                        window.__contactRecaptchaCallbacks = [];
                    };

                    const script = document.createElement('script');
                    script.src = 'https://www.google.com/recaptcha/enterprise.js?onload=__contactRecaptchaOnload&render=explicit';
                    script.async = true;
                    script.defer = true;
                    document.head.appendChild(script);
                    window.__contactRecaptchaScriptAdded = true;
                }
            },
            renderRecaptcha: function () {
                if (!this.ShouldUseRecaptcha || this.RecaptchaWidgetId !== null) {
                    return;
                }

                const container = this.$refs.recaptchaContainer;
                if (!container || !window.grecaptcha || !window.grecaptcha.enterprise || !window.grecaptcha.enterprise.render) {
                    return;
                }

                this.RecaptchaWidgetId = window.grecaptcha.enterprise.render(container, {
                    sitekey: this.RecaptchaSiteKey,
                    callback: (token) => this.onRecaptchaSuccess(token),
                    'expired-callback': () => this.onRecaptchaExpired(),
                    'error-callback': () => this.onRecaptchaError()
                });
            },
            onRecaptchaSuccess: function (token) {
                this.RecaptchaToken = token || '';
            },
            onRecaptchaExpired: function () {
                this.RecaptchaToken = '';
                if (window.grecaptcha && window.grecaptcha.enterprise && this.RecaptchaWidgetId !== null) {
                    window.grecaptcha.enterprise.reset(this.RecaptchaWidgetId);
                }
            },
            onRecaptchaError: function () {
                this.onRecaptchaExpired();
                toast.error("Unable to verify reCAPTCHA. Please try again.");
            },
            EditProperties: function () {
                var id = '#editor' + this.BlockProps.UId;
                var modalEl = document.querySelector(id);
                if (modalEl == null) {
                    return;
                }
                var modal = bootstrap.Modal.getOrCreateInstance(modalEl); // Returns a Bootstrap modal instance
                modal.show();
            },
            UploadNewSlideBackground: function(idx){
                this.HideEditProperties();
                var args = {};  

                var imgProp = 'Img' + idx;
                args.ExistingFileURL = this.BlockProps[imgProp];
                args.CompleteCallback = "OnSlideImageUploaded-" + this.BlockProps.UId;
                args.CompleteCallbackData = { MaxSize: 1024 * 75, idx: imgProp, url: ''}; // this will be sent back in the callback
                args.Prompt = `Image`;
                EventHub.$emit('UploadNewAssetBlockConfig', args);
            }
        },

        setup(props, context)
        {             
            return {} // anything returned here will be available for the rest of the component
        },
        created()
        {           
            EventHub.$on('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
        },
        beforeUnmount()
        {
            EventHub.$off('OnSlideImageUploaded-' + this.BlockProps.UId, this.OnSlideImageUploaded);      
            if (this.RecaptchaCallbackRef && window.__contactRecaptchaCallbacks) {
                window.__contactRecaptchaCallbacks = window.__contactRecaptchaCallbacks.filter(cb => cb !== this.RecaptchaCallbackRef);
            }
        },
        mounted() {
            nextTick().then(() => {
                if (this.ShouldUseRecaptcha) {
                    this.prepareRecaptcha();
                }
            });
        }
    }

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    /* Style the .contact-content div */
    .contact-content {
        background-repeat: no-repeat;
        background-size: cover;
        background-position: center;
        position: relative;
        z-index: 1;
    }

    .contact-content::before {
        content: "";
        display: block;
        position: absolute;
        z-index: -1;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        background: rgba(0,0,0,.7);
    }
    
        /* Style the content inside .contact-content */
        .contact-content .row {
            color: #fff; 
        }

        /* Style the content divs inside .contact-content */
        .contact-content .col-1 {
            /* Add your styling for the icon column */
        }

        .contact-content .col-11 {
            /* Add your styling for the address column */
        }
</style>

